// stores/GlobalStore.ts
import { observable, action } from 'mobx';

class GlobalStore {
  @observable navbarStick = false;

  @action
  toggleNavBarStickState(state) {
    this.navbarStick = state;
  }
}

// 创建全局 Store 实例（单例模式）
const globalStore = new GlobalStore();

export default globalStore;
